import styled from 'styled-components';
import { px } from '../../../../../../contrib/ui';

export const GrupScorecardsStyled = styled.div`
  display: flex;
  flex-direction: column;

  .title {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }

  button.button.override {
    width: ${px(150)};
    align-self: flex-end;
  }
`;
